import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const SOURCE_TYPE_COLORS = {
  "brokerboost-job-qualified": "#28a745",
  "brokerboost-job-unqualified": "#dc3545",
};

const CircularScoreProgress = ({
  score = null,
  size = 60,
  strokeWidth = 4,
  animate = true,
  sourceType = null,
}) => {
  const [progress, setProgress] = useState(0);

  const effectiveScore =
    score !== null && score !== undefined ? Number(score) : 0;

  const normalizedScore = effectiveScore > 0 ? (effectiveScore / 10) * 100 : 0;

  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (progress / 100) * circumference;

  const getCircleColor = () => {
    if (sourceType && SOURCE_TYPE_COLORS[sourceType]) {
      return SOURCE_TYPE_COLORS[sourceType];
    }
    return "transparent";
  };

  const getTextColor = () => {
    if (sourceType && SOURCE_TYPE_COLORS[sourceType]) {
      return SOURCE_TYPE_COLORS[sourceType];
    }
    return "#6c757d";
  };

  useEffect(() => {
    if (animate && effectiveScore > 0) {
      const timer = setTimeout(() => {
        setProgress(normalizedScore);
      }, 50);

      return () => clearTimeout(timer);
    }
    if (effectiveScore > 0) {
      setProgress(normalizedScore);
    }
    return () => {};
  }, [normalizedScore, animate, effectiveScore]);

  return (
    <div
      className="circular-score-progress"
      style={{ width: size, height: size }}
    >
      <svg className="progress-svg" width={size} height={size}>
        <circle
          className="background-circle"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="#ffffff"
        />
        <circle
          className="progress-circle"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          stroke={getCircleColor()}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="score-text">
        <span className="score-value" style={{ color: getTextColor() }}>
          {effectiveScore.toFixed(1)}
        </span>
      </div>
    </div>
  );
};

CircularScoreProgress.propTypes = {
  score: PropTypes.number,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  animate: PropTypes.bool,
  sourceType: PropTypes.string,
};

export default CircularScoreProgress;
